import * as _ from 'underscore';
import { ISiteRolePickerMenuScope, SiteRolePickerMenuHelper } from '../helpers/SiteRolePickerMenuHelper';
import { UsernameHelpers } from '../helpers/UsernameHelpers';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DefaultSiteRole, SiteRoleOption, SiteRoleOptionsResource } from '../resources/SiteRoleOptions';
import { SiteRolesResource } from '../resources/SiteRoles';
import { SiteUsers } from '../resources/SiteUsers';
import { IImportUsersFromActiveDirectoryResult } from '../ServerApi/requests/ImportUsersFromActiveDirectoryRequest';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { UserAddedEvent } from '../services/AddUsersOptionsAction';
import { ServerService } from '../services/ServerService';
import {
  UserActionNotification,
} from '../services/UserActionNotification';
import { ResultCode } from '../services/UserActionResultCode';

export class AddActiveDirectorySiteUsersDialogCtrl {

  public static $inject = [
    '$scope',
    '$q',
    '$translate',
    'ServerService',
    'SiteRoles',
    'SiteRoleOptionsResource',
    'SiteUsers',
    'UserActionNotification',

    // resolved in AddActiveDirectoryUsersAction
    'availableQuota'
  ];

  constructor(
    private $scope: AddActiveDirectorySiteUsersDialogCtrl.Scope,
    private $q: ng.IQService,
    $translate: ng.translate.ITranslateService,
    server: ServerService,
    siteRoles: SiteRolesResource,
    siteRoleOptionsResource: SiteRoleOptionsResource,
    private siteUsers: SiteUsers,
    private userActionNotification: UserActionNotification,
    availableQuota: number
  ) {

    // possible site roles settings for the imported group include everything except guest & admin.
    $scope.siteRoleOptions = siteRoles.optionsForCurrentUser();
    $scope.siteRole = availableQuota <= 0 ? SiteRoles.Unlicensed : DefaultSiteRole;
    $scope.setSiteRole = (role: string) => {
      $scope.siteRole = role;
    };

    const onSiteRoleSelected = (roleOption: SiteRoleOption) => {
      this.$scope.$apply(() => {
        $scope.siteRoleSelectorProps.selectedRole = roleOption;
        $scope.setSiteRole(roleOption.role); // also set $scope.siteRole so original behavior is unaltered
      });
    };

    SiteRolePickerMenuHelper.setupPickerMenuScope($scope, $translate, server, siteRoleOptionsResource, $scope.siteRole, onSiteRoleSelected, !server.isSessionServerAdmin());

    $scope.addActiveDirectoryUsers = (userTextInput: string) =>  this.importUsers(userTextInput);

    // TODO: dry this out. Duplicated in AddActiveDirectoryUsersAction.ts
    $scope.availableQuota = availableQuota;

    SiteRolePickerMenuHelper.setScopeToDisableAllLicensedRolesIfOutOfQuota($scope);

    $scope.isSiteRoleOptionDisabled = (siteRole: string) => {
      // when available quota is 0, only allow Unlicensed and UnlicensedWithPublish users to be added.
      return availableQuota <= 0 && siteRole !== SiteRoles.Unlicensed && siteRole !== SiteRoles.UnlicensedWithPublish;
    };
    $scope.isQuotaEnabledForSite = _.isNumber(availableQuota);
  }

  private importUsers(userTextInput: string): ng.IPromise<any> {
    this.$scope.busy = true;
    this.$scope.usersToAdd = UsernameHelpers.splitUsernames(userTextInput); // match strings delimited by semicolons & commas
    let siteRole = this.$scope.siteRole;

    let serverAdmin = false;
    if (siteRole === SiteRoles.ServerAdministrator) {
      siteRole = SiteRoles.Unlicensed;
      serverAdmin = true;
    }
    return this.siteUsers.importUsersFromActiveDirectory(this.$scope.usersToAdd, siteRole, serverAdmin).then(
      (result: IImportUsersFromActiveDirectoryResult) => {
        this.userActionNotification.notify({
          users: Set.fromIdItemArray(result.users),
          results: result.results,
          errors: result.errors,
          successCode: ResultCode.SiteUserCreated.toString(),
          siteRole : siteRole
        });
        this.$scope.$emit(UserAddedEvent);
        return this.$q.when({});
      })
    .then((result: any) => this.$scope.close(result));
  }

}

export module AddActiveDirectorySiteUsersDialogCtrl {

  export interface Scope extends ISiteRolePickerMenuScope {
    addActiveDirectoryUsers: (userTextInput: string) => void;
    busy: boolean;
    close: (result: any) => void;
    usersToAdd: string[];
    setSiteRole(role: string): void;
    siteUsers: SiteUsers;
    siteRole: string;
    siteRoleOptions: string[];

    // quota
    availableQuota: number;
    isQuotaEnabledForSite: boolean;
    isSiteRoleOptionDisabled(siteRole: string): boolean;
  }

}

Module.instance().controller('AddActiveDirectorySiteUsersDialogCtrl', AddActiveDirectorySiteUsersDialogCtrl);
